var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManBeard3A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "frame_730px_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "beard_x5F_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x34__1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M467.4,325.7c-1.2-2.3-4.3-6.3-5.8-8.3c-9.6-13-8.7-37.8-5.7-61.5c0.2-1.9,0.2-3.9,0.1-3.7 c-5.1,7.7-5.9,29.3-6.8,38.9c-1,10.5-3.4,17.6-10.6,25.7c-7.5,8.6-13.3,13.1-15.5,23.9c-0.6,3.1-1,12.5-5.3,13.4 c-5.5,1.1-8.4-7-10.3-10c-4.5-7.5-11.5-16.3-20.6-15.1c-4.8,0.7-9.3,4.7-13.8,6.2c-9.1,3.4-21.9,1.4-29.8-1.2 c-4.5-1.5-7.1-3.9-11.9-4.6c-9.1-1.3-19.3,9-23.8,16.5c-1.8,3.1-5.3,11.7-10.8,10.6c-4.3-0.8-5-12.7-5.6-15.8 c-2.2-10.8-8-15.3-15.5-23.9c-7.1-8.2-9.5-15.2-10.6-25.7c-0.9-9.5-0.7-31.3-6.6-39.8c1.9,18.5,2.5,39.8-4.2,60.8 c-0.8,2.4-6.8,13.7-8,16c3-1.4,9.5-6.9,11.4-10.1c-1,8.7-5.8,15.7-8.9,23.7c3,0.4,5.9-1.8,8.4-2.9c1.6,6.9-1.4,18.5-3.6,24.9 c3.8,0.1,9.9-2.3,10.7-5.7c0.1,5.7-0.4,10.6-1.3,16c4.4,0.3,10.9-3.2,12-7.1c2.8,6.6,3.9,10.6,6,18.4c1.3,4.7,0.3,4.9,4.8,2.4 c2.3-1.2,4.9-5.8,5.9-8.1c3,7.8,16.1,8.5,19.9,13.3c-5.6-18.6,2.3-48.5,24.2-51.6c9.1-1.3,8.8-1.2,19.4-1.1l0,0c0.6,0,1.1,0,1.6,0 c0.6,0,1.2,0,1.9,0l0,0c11.2-0.1,19.3-0.5,28.5,0.8c21.9,3.1,23.7,35.4,16,51.6c4.1-2.8,16-5.2,19-13c1,2.3,3.7,6.8,5.9,8.1 c4.5,2.5,3.1,2.1,4.8-2.4c2.5-6.2,4.1-12.4,6-18.4c1.2,3.8,7.6,7.4,12,7.1c-1-5.4-1.4-10.3-1.3-16c0.9,3.3,6.9,5.8,10.7,5.7 c-2.1-6.5-5.2-15.3-3.6-22.2c2.4,1.1,5,2.4,8.1,2c-4.7-7.4-8.6-14.4-9.5-23.1C457.5,323.6,463.5,325.4,467.4,325.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManBeard3A);
export default __webpack_public_path__ + "static/media/man_beard_3a.1d06c41d9d2cf1fa6e6cd9d737ca57af.svg";
export { ForwardRef as ReactComponent };